<template>
    <div class="updateForm">
        <ul class="updateFormList">
            <li class="tab" :class="activeTab=='basicDetails' ? 'active' : ''" @click="activeTab = 'basicDetails'">Basic Details</li>
            <li class="tab" :class="activeTab=='vCardModel' ? 'active' : ''" @click="activeTab = 'vCardModel'">VCard models</li>
            <li class="tab" :class="activeTab=='workingHour' ? 'active' : ''" @click="activeTab = 'workingHour'">Working hours</li>
            <li class="tab" :class="activeTab=='services' ? 'active' : ''" @click="activeTab = 'services'">Services</li>
            <li class="tab" :class="activeTab=='products' ? 'active' : ''" @click="activeTab = 'products'">Products</li>
            <!-- <li class="tab" :class="activeTab=='temoin' ? 'active' : ''" @click="activeTab = 'temoin'">Testimonials</li> -->
            <li class="tab" :class="activeTab=='socialLink' ? 'active' : ''" @click="activeTab = 'socialLink'">Social Links - Website</li>
            <li class="tab" :class="activeTab=='catalogue' ? 'active' : ''" @click="activeTab = 'catalogue'">Catalogs</li>
            <li class="tab" :class="activeTab=='message' ? 'active' : ''" @click="activeTab = 'message'">Messages</li>
        </ul>
        <div class="tabContents">
            <basicDetails v-if="activeTab == 'basicDetails'" :cardInfo="blog"></basicDetails>
            <vCardModel  v-if="activeTab == 'vCardModel'" :cardInfo="blog"></vCardModel>
            <heuresDeTravail v-if="activeTab == 'workingHour'" :cardInfo="blog"></heuresDeTravail>
            <prestationsDeService v-if="activeTab == 'services'" :cardInfo="blog"></prestationsDeService>
            <desProduits v-if="activeTab == 'products'" :cardInfo="blog"></desProduits>
            <temoignages v-if="activeTab == 'temoin'" :cardInfo="blog"></temoignages>
            <lienSociaux v-if="activeTab == 'socialLink'" :cardInfo="blog"></lienSociaux>
            <calogue v-if="activeTab == 'catalogue'" :cardInfo="blog"></calogue>
            <messages v-if="activeTab == 'message'" :cardInfo="blog"></messages>
        </div>
    </div>
</template>
<script>

import basicDetails from './../tabContents/basicDetails.vue'
import vCardModel from "./../tabContents/modelesDeVCard.vue"
import heuresDeTravail from './../tabContents/heuresDeTravail.vue'
import prestationsDeService from './../tabContents/prestationsDeService.vue'
import desProduits from './../tabContents/desProduits.vue'
import temoignages from './../tabContents/temoignages.vue'
import lienSociaux from './../tabContents/lienSociaux.vue'
import calogue from "./../tabContents/calogue.vue"
import messages from "./../tabContents/messages.vue"



export default {
    name: "UpdateBlog" ,
    data() {
        return {
            image : "" , 
            title : "" , 
            decription: '',

            activeTab: "basicDetails"
        }
    },
    components: { basicDetails,vCardModel, heuresDeTravail, prestationsDeService, desProduits, temoignages, lienSociaux, calogue, messages},
    async created(){

    },
    props : {
        blog : Object
    },
    methods : {

    }
}
</script>

<style scoped lang="scss">
    $primary_color: #00468b;
    .updateForm {
        .updateFormList {
            display: flex;
            justify-content: space-around;
            width: 100%;
            flex-wrap: wrap;
            li {
                list-style: none;
                cursor: pointer;
                position: relative;
                transition: all 0.4s ease-in-out;
                &:after {
                    content: "";
                    position: absolute;
                    width: 0%;
                    transition: all 0.4s ease-in-out;
                }
                &:hover {
                    font-weight: bold;
                    position: relative;
                    color: black;
                    &:after {
                        content: "";
                        position: absolute;
                        width: 100%;
                        height: 3px;
                        background-color: $primary_color;
                        bottom: -20%;
                        left: 0;
                    }
                }
            }
            .active {
                font-weight: bold;
                position: relative;
                color: black;
                &:after {
                    content: "";
                    position: absolute;
                    width: 100%;
                    height: 3px;
                    background-color: $primary_color;
                    bottom: -20%;
                    left: 0;
                }
            }
        }
    }
</style>

